import {
  Directive,
  HostListener,
  booleanAttribute,
  inject,
  input
} from '@angular/core';

import { EXTERNAL_LINK_CLEANER_CONFIG } from '../external-link-cleaner-options';
import { handleExternalLinkClick } from '../handlers/external-link-click-handler';

@Directive({
  selector: '[livGaLinkCleaner]',
  standalone: true
})
export class GaLinkCleanerDirective {
  private readonly config = inject(EXTERNAL_LINK_CLEANER_CONFIG);

  /**
   * Ativa/desativa a limpeza de parâmetros de rastreamento.
   * @default true
   */
  enabled = input(true, {
    alias: 'livGaLinkCleaner',
    transform: booleanAttribute
  });

  /**
   * Parâmetros de rastreamento a serem removidos.
   * Aceita string única (ex: '_gl') ou array (ex: ['_gl', '_ga']).
   */
  trackingParams = input<string[], string[] | string | undefined>(undefined, {
    transform: (value) =>
      value === undefined ? undefined : Array.isArray(value) ? value : [value]
  });

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent): boolean {
    if (event.defaultPrevented || !this.enabled()) {
      return false;
    }

    const link = event.currentTarget as HTMLAnchorElement;

    return handleExternalLinkClick({
      event,
      link,
      trackingParams: this.trackingParams() ?? this.config.trackingParams,
      appDomain: this.config.appDomain,
      skipDomainFilter: true
    });
  }
}
